var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_325_1340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_325_1340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6999 13.1998V11.0998H15.5999V9.2998H17.6999V7.1998H19.4999V9.2998H21.5999V11.0998H19.4999V13.1998H17.6999ZM9.5999 11.9998C8.5999 11.9998 7.7499 11.6498 7.0499 10.9498C6.3499 10.2498 5.9999 9.3998 5.9999 8.3998C5.9999 7.3998 6.3499 6.5498 7.0499 5.8498C7.7499 5.1498 8.5999 4.7998 9.5999 4.7998C10.5999 4.7998 11.4499 5.1498 12.1499 5.8498C12.8499 6.5498 13.1999 7.3998 13.1999 8.3998C13.1999 9.3998 12.8499 10.2498 12.1499 10.9498C11.4499 11.6498 10.5999 11.9998 9.5999 11.9998ZM2.3999 19.1998V16.8998C2.3999 16.4701 2.50407 16.0752 2.7124 15.7151C2.92074 15.3549 3.20824 15.0665 3.5749 14.8498C4.49157 14.3165 5.45824 13.9081 6.4749 13.6248C7.49157 13.3415 8.53324 13.1998 9.5999 13.1998C10.6666 13.1998 11.7082 13.3415 12.7249 13.6248C13.7416 13.9081 14.7082 14.3165 15.6249 14.8498C15.9916 15.0665 16.2791 15.3549 16.4874 15.7151C16.6957 16.0752 16.7999 16.4701 16.7999 16.8998V19.1998H2.3999ZM4.1999 17.3998H14.9999V16.8998C14.9999 16.792 14.9747 16.694 14.9242 16.6058C14.8738 16.5175 14.8074 16.4488 14.7249 16.3998C13.9416 15.9498 13.1166 15.604 12.2499 15.3623C11.3832 15.1206 10.4999 14.9998 9.5999 14.9998C8.6999 14.9998 7.81657 15.1206 6.9499 15.3623C6.08324 15.604 5.25824 15.9498 4.4749 16.3998C4.3924 16.4488 4.3259 16.5175 4.2754 16.6058C4.22507 16.694 4.1999 16.792 4.1999 16.8998V17.3998ZM9.60515 10.1998C10.1017 10.1998 10.5249 10.0231 10.8749 9.66955C11.2249 9.31605 11.3999 8.89105 11.3999 8.39455C11.3999 7.89805 11.2232 7.4748 10.8697 7.1248C10.5162 6.7748 10.0912 6.5998 9.59465 6.5998C9.09815 6.5998 8.6749 6.77656 8.3249 7.13006C7.9749 7.48356 7.7999 7.90856 7.7999 8.40506C7.7999 8.90156 7.97665 9.3248 8.33015 9.6748C8.68365 10.0248 9.10865 10.1998 9.60515 10.1998Z",
    fill: "#5386E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.87a8550697b3057e024e114742598ba5.svg";
export { ForwardRef as ReactComponent };